import React from 'react';
import SearchInput from '@/components/SearchInput';
import type { ActionType } from '@/lib/types';

interface BottomSearchBarProps {
  question: string;
  onQuestionChange: (q: string) => void;
  isLoading: boolean;
  loadingType: ActionType | null;
  answerSize: number;
  onAnswerSizeChange: (size: number) => void;
  onSearch: () => void;
  onAnalyze: () => void;
}

const BottomSearchBar: React.FC<BottomSearchBarProps> = ({
  question,
  onQuestionChange,
  isLoading,
  loadingType,
  answerSize,
  onAnswerSizeChange,
  onSearch,
  onAnalyze,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border animate-slide-in-bottom">
      <div className="max-w-3xl mx-auto px-4 py-4">
        <SearchInput
          value={question}
          onChange={onQuestionChange}
          isLoading={isLoading}
          loadingType={loadingType || undefined}
          onSearch={onSearch}
          onAnalyze={onAnalyze}
          answerSize={answerSize}
          onAnswerSizeChange={onAnswerSizeChange}
        />
      </div>
      {/* Disclaimer like Mistral */}
      <p className="text-xs text-muted-foreground/60 text-center pb-3">
        L'IA peut faire des erreurs. Vérifiez les réponses.
      </p>
    </div>
  );
};

export default BottomSearchBar;
